import Vue from 'vue'
import Vuex from 'vuex'
import application from './application'
import skiliko from './skiliko'
// import localStorageSync from '@/plugins/localStorageSync'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    application,
    skiliko
  },
  // plugins: [
  //   localStorageSync
  // ],
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/store/index.js